import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../actions/actions';
import ErrorBoundary from '../components/errorBoundary';
import Layout from '../components/layout';
import isNil from '~/_base/functions/isNil';
import Spinner from '~/_base/components/spinner';

class App extends React.Component {
  constructor(props) {
    super();
    this.state = {
      projectName: '',
      setMap: false,
    };
    props.Actions.getProjectInfo();
  }

  render() {
    const { Timetravel } = this.props.state;
    
    const featureCollection = {
      type: 'FeatureCollection',
      features: Timetravel.mapData,
    };

    return (
      <ErrorBoundary>
        <div id="timetravel-wrapper">
          {isNil(Timetravel.project) ? (
            <Spinner />
          ) : (
            <Layout
              initialised={Timetravel.initialised}
              projectId={Timetravel.project.id}
              boundingRectangle={Timetravel.boundingRectangle}
              filters={Timetravel.filters}
              eventStart={Timetravel.eventStart}
              eventEnd={Timetravel.eventEnd}
              eventActivity={Timetravel.eventActivity}
              mapData={featureCollection}
              feedData={Timetravel.feedData}
              actions={this.props.Actions}
              gettingFeed={Timetravel.gettingFeed}
              gettingMap={Timetravel.gettingMap}
              gettingChart={Timetravel.gettingChart}
              renderChart={Timetravel.renderChart}
              feedDataSelectedIndex={Timetravel.feedDataSelectedIndex}
            />
          )}
        </div>
      </ErrorBoundary>
    );
  }
}

function mapStateToProps(state) {
  return { state: state };
}

function mapDispatchToProps(dispatch) {
  return {
    Actions: bindActionCreators(Actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
